import SolutionsControls from './SolutionsControls';

export default function EquationToolbar({ block, onUpdateBlockData, plugins }) {
  const blockData = block.getData();
  return <>{plugins?.solutions && <SolutionsControls blockData={blockData} onUpdateBlockData={onUpdateBlockData} />}</>;
}
